import React from 'react';
import {useForm} from 'react-final-form';

export default function CareerLevel({careerLevel}) {
    const form = useForm();
    const value = form.getState().values.careerLevel;

    const select = (key) => {
        form.change('careerLevel', key);
    };

    if (!careerLevel) return null;

    return <div className="resume-form__career-level">
        <div className="resume-form__tab-selector">
            {Object.entries(careerLevel).map(([key, career]) => (
                <div key={key}
                     className={`tab-select ${value === key ? 'active' : ''}`}
                     onClick={() => select(key)}>
                    <a><strong>{career.name}</strong><span className="annotation">{career.annotation}</span></a>
                </div>
            ))}
        </div>
    </div>;
}
